import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import Finances from './pages/Finances/Finances';
import Statistics from './pages/Statistics/Statistics';
import Settings from './pages/Settings/Settings';
import Profile from './pages/Profile/Profile';
import Databases from './pages/Databases/Databases';
import Login from './pages/Auth/Login/Login';
import Forgot from './pages/Auth/Forgot/Forgot';
import Register from './pages/Auth/Register/Register';
import Users from './pages/Users/Users';
import ClientsPage from './pages/Clients/Clients';
import WebsitesPage from './pages/Websites/Websites';
import ShipperPage from './pages/Shippers/Shippers';
import MarineLinePage from './pages/Marines/Marines';
import PrivateRoute from './pages/PrivateRoute/PrivateRoute';

import { AuthProvider, useAuth } from './providers/authProvider';
import DealersPage from './pages/Dealers/Dealers';
import TransportPricesPage from './pages/TransportPrices/Prices';
import RolesPage from './pages/Roles/Users';
import PermissionsPage from './pages/Permissions/Permissions';
import SalariesPage from './pages/Salaries/Salaries';
import LogsPage from './pages/Logs/Salaries';
import MessagesPage from './pages/Messages/Messages'; 
import NewUsersPage from './pages/NewUsers/NewUsers';
import ContainerPage from './pages/Containers/Containers';
import { AppContext } from './providers/appProvider';
import FinancePage from './pages/Finances/FinancePage';
import FinanceAdd from './pages/Finances/FinanceAdd';
import CarPhotos from './pages/Finances/CarPhotos';
import CarDealerPage from './pages/Finances/CarDealerPage';
import CarRate from './pages/Finances/CarRate';
import InvoicesPage from './pages/Invoice/Invoices';
import ContainerPricesPage from './pages/ContainerPrice/Prices';
import AgentsPage from './pages/Agents/Agents';
import AgentCRMPage from './pages/AgentCRM/AgentCRM';
import TasksPage from './pages/Tasks/Tasks';
import Parser from './pages/Parser/Parser';
import Calculator from './pages/Calculator/Calculator';
import QuotationPage from './pages/Quotation/Quotation';
import BookingPage from './pages/Booking/Booking';
import TitlesPage from './pages/Titles/Titles';
import AuctionFeesPage from './pages/AuctionFees/AuctionFees'; 

function CustomRoutes() {

  const auth = useAuth();
  const { appState, app } = useContext(AppContext);
  const canShowUsers = app.hasPermission("USER_PAGE_SHOW");
  const canRegisterOwnDealer = app.hasPermission("USER_DEALER_REGISTER_OWN") && !canShowUsers;

  return (

    <Routes>
 
      <Route path="/c/:id" element={<CarPhotos />} />
 
      {app.hasPermission("FEEDBACK_SHOW") &&
        <Route path="/car-rate/:id" element={<PrivateRoute><CarRate /></PrivateRoute>} />
      }
      

      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<Forgot />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<Login />} />

      <Route path="/dashboard" element={<PrivateRoute> <Dashboard />  </PrivateRoute>} />
  
      {app.hasPermission("FINANCE_VIEW") &&
      <>
        <Route path="/finances" element={<PrivateRoute> <Finances /> </PrivateRoute>} />
        <Route path="/dealer/car/:id" element={<PrivateRoute> <CarDealerPage /> </PrivateRoute>} />
      </>
      } 
 

      {app.hasPermission("CALCULATOR_SHOW") &&
        <Route path="/calculator" element={<PrivateRoute> <Calculator /> </PrivateRoute>} />
      }  

      {app.hasPermission("PARSER_PAGE") &&
        <Route path="/parser" element={<PrivateRoute> <Parser /> </PrivateRoute>} />
      }  

      
      {app.hasPermission("FINANCE_EDIT") &&
        <Route path="/finances/edit/:id" element={<PrivateRoute><FinancePage /></PrivateRoute>} />
      }
      
      {app.hasPermission("FINANCE_EDIT_IF_CAR_PRICE_0") &&
        <Route path="/finances/edit/:id" element={<PrivateRoute><FinancePage /></PrivateRoute>} />
      }

      {app.hasPermission("FINANCE_ADD") &&
        <Route path="/finances/add" element={<PrivateRoute><FinanceAdd /></PrivateRoute>} />
      }

      {app.hasPermission("CONTAINER_PAGE_SHOW") &&
        <Route path="/containers" element={<PrivateRoute> <ContainerPage /> </PrivateRoute>} />
      }

      {app.hasPermission("SHIPPER_PAGE_SHOW") &&
        <Route path="/databases/shippers" element={<PrivateRoute> <ShipperPage /> </PrivateRoute>} />
      }

      {app.hasPermission("MARINE_LINE_PAGE_SHOW") &&
        <Route path="/databases/marine_lines" element={<PrivateRoute> <MarineLinePage /> </PrivateRoute>} />
      }

      {app.hasPermission("TITLES_PAGE_SHOW") &&
        <Route path="/databases/titles" element={<PrivateRoute> <TitlesPage /> </PrivateRoute>} />
      }

      {app.hasPermission("AUCTION_FEES_PAGE_SHOW") &&
        <Route path="/databases/auction-fees" element={<PrivateRoute> <AuctionFeesPage /> </PrivateRoute>} />
      }
      
      {app.hasPermission("SITES_PAGE_SHOW") &&
        <Route path="/transport-prices/websites" element={<PrivateRoute> <WebsitesPage /> </PrivateRoute>} />
      }

      {app.hasPermission("AGENTCRM_PAGE_SHOW") &&
        <Route path="/transport-prices/agentcrm" element={<PrivateRoute> <AgentCRMPage /> </PrivateRoute>} />
      }
 
      {app.hasPermission("AGENTS_PAGE_SHOW") &&
        <Route path="/databases/agents" element={<PrivateRoute> <AgentsPage /> </PrivateRoute>} />
      }  
 
      {app.hasPermission("TASKS_PAGE_SHOW") &&
        <Route path="/tasks" element={<PrivateRoute> <TasksPage /> </PrivateRoute>} />
      }
 
      {app.hasPermission("INVOICE_PAGE_SHOW") &&
        <Route path="/databases/invoices" element={<PrivateRoute> <InvoicesPage /> </PrivateRoute>} />
      }
 
  
 
      {app.hasPermission("TRANSPORT_PRICE_PAGE_SHOW") &&
        <Route path="/transport-prices" element={<PrivateRoute> <TransportPricesPage /> </PrivateRoute>} />
      }
     
     {app.hasPermission("CONTAINER_PAGE_SHOW") &&
        <Route path="/container-prices" element={<PrivateRoute> <ContainerPricesPage /> </PrivateRoute>} />
      }
 
      {app.hasPermission("QUOTATION_PAGE_SHOW") &&
        <Route path="/quotation" element={<PrivateRoute> <QuotationPage /> </PrivateRoute>} />
      }

      {app.hasPermission("BOOKING_PAGE_SHOW") &&
        <Route path="/booking" element={<PrivateRoute> <BookingPage /> </PrivateRoute>} />
      }

      {app.hasPermission("SALARY_PAGE_SHOW") &&
        <Route path="/salaries" element={<PrivateRoute> <SalariesPage /> </PrivateRoute>} />
      }

      {app.hasPermission("LOG_PAGE_SHOW") &&
        <Route path="/logs" element={<PrivateRoute> <LogsPage /> </PrivateRoute>} />
      }

      {app.hasPermission("SMS_PAGE_SHOW") &&
        <Route path="/sms" element={<PrivateRoute> <MessagesPage /> </PrivateRoute>} />
      } 

      <Route path="/databases" element={<PrivateRoute> <Databases /> </PrivateRoute>} />

      {canShowUsers &&
        <>
          <Route path="/users/new" element={<PrivateRoute> <NewUsersPage /> </PrivateRoute>} />
          <Route path="/users/dealers" element={<PrivateRoute> <DealersPage /> </PrivateRoute>} />
          <Route path="/databases/roles" element={<PrivateRoute> <RolesPage /> </PrivateRoute>} />
          <Route path="/databases/permissions" element={<PrivateRoute> <PermissionsPage /> </PrivateRoute>} />
          <Route path="/users/clients" element={<PrivateRoute> <ClientsPage /> </PrivateRoute>} />
          <Route path="/users/:roleId" element={<PrivateRoute> <Users /> </PrivateRoute>} />
        </>
      }

      {canRegisterOwnDealer &&
        <Route path="/users/:roleId" element={<PrivateRoute> <Users /> </PrivateRoute>} />
      }

      <Route path="/statistics" element={<PrivateRoute> <Statistics /> </PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute> <Settings /> </PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute> <Profile /> </PrivateRoute>} />

    </Routes>

  );
}

export default CustomRoutes;
